export const EDIT_MODE_GUTTER = 56
export const WORKSPACE_BAR_WIDTH = 200
export const APP_SIDE_NAV_WIDTH = 270
